// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "#toemails-multiselect,\n#ccemails-multiselect,\n#bccemails-multiselect {\n  text-transform: lowercase !important;\n}", ""]);
// Exports
module.exports = exports;
